<div class="info-page terms-and-conditions-arztapp">
	<div class="info-page-container">
		<div class="info-page-header">
			<span class="text-4xl">Allgemeine Geschäftsbedingungen</span>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 1 Allgemeines
			</div>
			<div class="text-block-content">
				<p> Die Nutzung dieser Webseite richtet sich nach den vorliegenden allgemeinen Geschäftsbedingungen.
					Abweichende Vereinbarungen bedürfen der Schriftform.
				</p>
				<p>Anbieterin ist: Patriacura als Marke der Aliscura e.K. im Folgenden „Anbieterin“ genannt</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 2 Leistungsumfang
			</div>
			<div class="text-block-content">
				<p> Die Anbieterin stellt Ärzten und Apotheken eine Internet-Plattform zur Verfügung, über die Patienten
					online ärztliche Leistungen erhalten und Rezepte an ihre Wunschapotheke schicken lassen können. Die
					Plattform dient insbesondere der Online-Behandlung zur Ausstellung von Rezepten.
					Die Plattform wählt keine Apotheken aus und weist keine Patienten zu. Sie steht allen Apotheken
					offen.
				</p>
				<p class="py-2">Leistungsmerkmale:</p>
				<li>Symptomerhebung und Übermittlung an Ärzte</li>
				<li>Ausschluss ungeeigneter Patienten</li>
				<li>Qualitätssicherung und Datenschutz</li>
				<li>Benutzerfreundlichkeit</li>
				<li>Datensicherheit</li>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 3 Kosten
			</div>
			<div class="text-block-content">
				<p> Die Nutzung der Services ist kostenpflichtig. Die Preise sind jeweils angegeben und enthalten
					insbesondere die Gebühren für ärztliche Leistungen.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 4 Vertragsschluss
			</div>
			<div class="text-block-content">
				<p>Arzneimittel: Vertrag zwischen Nutzer und Apotheke. Datenübermittlung gilt als Angebot, Annahme durch
					Bestätigung oder Lieferung. Behandlung: Vertrag zwischen Nutzer und Arzt. Datenübermittlung gilt als
					Angebot, Annahme durch Ausführung der Leistung. Bei Nichtzustandekommen können dennoch Gebühren
					anfallen.</p>
				<p>Der Behandlungsvertrag erfolgt zwischen Patient und behandelndem Arzt.</p>
				<p>Zahlung und Abrechnung erfolgen über Anbieterin im Namen der Leistungserbringer. Anbieterin ist
					selbst nicht Vertragspartner.</p>
				<p>Der Nutzer gibt seine Ausdrückliche Zustimmung zur Ausführung der Dienstleistungen und bestätigt
					seine Kenntnis davon, dass er sein Widerrufsrecht wo dies zulässig ist verlieren kann.
				</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 5 Informationspflichten
			</div>
			<div class="text-block-content">
				<p>Es besteht kein außergerichtliches Beschwerdeverfahren und es besteht auch keine Verpflichtung dazu.
					Vertragssprache ist Deutsch.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 6 Nutzungsrechte
			</div>
			<div class="text-block-content">
				<p>Dem Nutzer stehen nur die in der AGB genannten Rechte zu. Inhalte der Webseite sind urheberrechtlich
					geschützt. Weitergabe nur mit schriftlicher Zustimmung der Anbieterin.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 7 Nutzerdaten
			</div>
			<div class="text-block-content">
				<p> Datenverarbeitung erfolgt nur mit Einwilligung. Die Speicherung erfolgt auf deutschen Servern.
					Nutzer stimmt medizinischer Nutzung der Daten durch Fachpersonal zu. Daten können anonymisiert
					wissenschaftlich ausgewertet werden. Siehe hierzu die Datenschutzerklärung.</p>

			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 8 Verfügbarkeit
			</div>
			<div class="text-block-content">
				<p>Es besteht kein Recht auf Verfügbarkeit das Angebots.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 9 Haftung
			</div>
			<div class="text-block-content">
				<p>Haftung nur bei wesentlichen Vertragspflichten oder gesetzlicher Pflicht. Keine Haftung für Behandlungs- oder Medikationsfehler. Diese liegen im Verantwortungsbereich des jeweiligen behandelnden Arztes. Keine Haftung für mittelbare Schäden oder höhere Gewalt.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 10 Pflichten des Nutzers
			</div>
			<div class="text-block-content">
				<p>Angaben müssen korrekt und vollständig sein. Leistungen sind sachgerecht zu nutzen.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 11 Sperrung
			</div>
			<div class="text-block-content">
				<p>Bei Verdacht auf Missbrauch kann der Zugang gesperrt werden.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 12 Zahlung
			</div>
			<div class="text-block-content">
				<p>Abwicklung über PayPal oder Banküberweisung nach deren Bedingungen. Die Erstellung von Rezepten kann die erfolgte Zahlung geknüpft sein.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 13 Kommunikation
			</div>
			<div class="text-block-content">
				<p>Die Kommunikation erfolgt in der Regel per E-Mail. Der Nutzer stellt sicher, dass die angegebene E-Mail-Adresse erreichbar ist.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 14 Schlussbestimmungen
			</div>
			<div class="text-block-content">
				<p>Anwendbar ist deutsches Recht. Gerichtsstand ist Scheinfeld. Sollten einzelne Regelungen unwirksam sein, bleiben übrige gültig. Anstelle unwirksamer Bestimmungen gelten die gesetzlichen Regelungen.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 15 Widerrufsbelehrung
			</div>
			<div class="text-block-content">
				<p>Widerrufsrecht besteht nicht für medizinische Leistungen oder individuelle Herstellungen. Für andere Leistungen gilt eine 14-tägige Widerrufsfrist ab Vertragsabschluss. Der Widerruf kann formlos per E-Mail erfolgen. Bei vollständiger Leistungserbringung erlischt das Widerrufsrecht.</p>
				<p>Muster-Widerrufsformular:</p>
				<p>(Wenn Sie den Vertrag widerrufen wollen, senden Sie dieses Formular an die Anbieterin.)
					Hiermit widerrufe ich den Vertrag über die Erbringung folgender Dienstleistung:
					Bestellt am: Erhalten am: Name: Anschrift: Unterschrift (bei Papierform): Datum:</p>
				<p>– Ende der Widerrufsbelehrung –</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 16 Änderungen der AGB
			</div>
			<div class="text-block-content">
				<p>Die Anbieterin behält sich vor, diese AGB jederzeit zu ändern. Der Nutzer ist verpflichtet bei Nutzung der Dienste stets die aktuelle Version zu beachten.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				§ 17 Salvatorische Klausel
			</div>
			<div class="text-block-content">
				<p>Sollte eine Bestimmung dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. Anstelle der unwirksamen Regelung gilt diejenige Vorschrift, die der unwirksamen am nähesten kommt.</p>
			</div>
		</div>
	</div>
</div>

<div class="info-page terms-and-conditions-einhorn">
	<div class="info-page-container">
		<div class="info-page-header">
			<span class="text-4xl">Allgemeine Geschäftsbedingungen</span>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				1. Geltungsbereich und Vertragspartner
			</div>
			<div class="text-block-content">
				<p> Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, Lieferungen und sonstigen Leistungen, die zwischen der Einhorn-Apotheke Bad Windsheim – Dr. Philipp Hohnstein e.K. , Marktplatz 3, 91438 Bad Windsheim, 09841 - 2074, einhorn-apotheke&#64;patriamed.de (nachfolgend „Apotheke“) und ihren Kunden (nachfolgend „Kunde“ oder „Kunden“) über die Webseiten der Apotheke sowie über digitale Plattformen, auf denen die Apotheke ihre Produkte anbietet, zustande kommen.
				</p>
				<p>Diese AGB gelten ausschließlich für Verbraucher im Sinne von §13 BGB. Unternehmer im Sinne von §14 BGB sind von der Nutzung dieser Plattform und vom Vertragsschluss ausgeschlossen, soweit nicht ausdrücklich etwas anderes vereinbart wurde.</p>
				<p>Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, die Apotheke stimmt ihrer Geltung ausdrücklich schriftlich zu.</p>
				<p>Die Apotheke ist Inhaberin einer gültigen Apothekenbetriebserlaubnis nach §2 ApoG sowie einer gültigen Versandhandelserlaubnis nach §11a ApoG. Das Angebot richtet sich ausschließlich an volljährige Personen mit Wohnsitz in Deutschland.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				2. Nutzung der Webseite, Registrierung und Kundenkonto
			</div>
			<div class="text-block-content">
				<li>Die Nutzung der Webseiten der Apotheke ist grundsätzlich ohne Registrierung möglich. Für bestimmte Funktionen (z. B. Arzneimittelreservierung oder Bestellungen) kann jedoch ein Kundenkonto erforderlich sein.</li>
				<li>Die Registrierung eines Kundenkontos ist ausschließlich volljährigen natürlichen Personen mit Wohnsitz in Deutschland gestattet, die als Verbraucher handeln.</li>
				<li>Es besteht kein Anspruch auf Registrierung oder Nutzung der Plattform.</li>
				<li>Bei der Registrierung sind wahrheitsgemäße und vollständige Angaben zu machen. Der Kunde ist verpflichtet, seine Zugangsdaten geheim zu halten und darf diese nicht an Dritte weitergeben.</li>
				<li>Der Kunde ist verpflichtet, die Apotheke unverzüglich zu informieren, falls unbefugte Dritte Kenntnis von seinen Zugangsdaten erlangt haben.</li>
				<li>Eine Mehrfachregistrierung ist nicht gestattet.</li>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				3. Vertragsschluss
			</div>
			<div class="text-block-content">
				<div class="font-bold">a) Allgemeines</div>
				<p>Die Darstellung von Arzneimitteln oder anderen Produkten auf der Website stellt kein rechtlich bindendes Angebot dar, sondern eine unverbindliche Produktinformation. Gleiches gilt insbesondere auch für externe Vergleichsportale.</p>
				<div class="font-bold">b) Bestellung von verschreibungspflichtigen Arzneimitteln</div>
				<li>Bei verschreibungspflichtigen Arzneimitteln gibt der Kunde ein verbindliches Angebot zum Abschluss eines Kaufvertrages ab, sobald er der Apotheke ein gültiges Originalrezept per Post oder persönlich zukommen lässt.</li>
				<li>Die Apotheke nimmt das Angebot erst durch ausdrückliche Bestätigung (z. B. Versandbestätigung per E-Mail) oder durch Auslieferung der Ware an.</li>
				<li>Falls ein Arzneimittel nicht lieferbar ist oder sich aus der Rezeptprüfung Änderungsbedarf ergibt, behält sich die Apotheke vor, die Bestellung abzulehnen oder Änderungen vorzuschlagen, bzw. diese mit der verschreibenden Praxis abzuklären. Der Kunde erklärt sich durch Einreichen des Rezepts damit einverstanden, dass die Apotheke die verschreibende Praxis zwecks Klärung kontaktieren darf.</li>
				<div class="font-bold">c) Bestellung rezeptfreier Produkte</div>
				<li>Für nicht verschreibungspflichtige Arzneimittel oder sonstige Produkte gibt der Kunde durch Absenden der Bestellung über die Webseite ein verbindliches Angebot zum Abschluss eines Kaufvertrags ab.</li>
				<li>Der Vertrag kommt durch Annahme der Bestellung in Form einer Bestell- oder Versandbestätigung oder durch Auslieferung der Ware zustande.</li>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				4. Preise und Zahlungsbedingungen
			</div>
			<div class="text-block-content">
				<li>Es gelten die Preise zum Zeitpunkt des Eingangs der Bestellannahme durch die Apotheke, inklusive der gesetzlichen Mehrwertsteuer.</li>
				<li>Die Apotheke informiert den Kunden vor Vertragsschluss über ggf. zusätzlich anfallende Versandkosten.</li>
				<li>Folgende Zahlungsarten können angeboten werden (abhängig von der Prüfung durch die Apotheke):</li>
				<li>Vorkasse (Überweisung)</li>
				<li>PayPal</li>
				<li>andere angebotene Zahlungsarten</li>
				<li>Die Apotheke behält sich vor, vorab eine Bonitätsprüfung durchzuführen. Hierzu können Daten an Wirtschaftsauskunfteien übermittelt werden. Dies erfolgt ausschließlich zum Zweck der Bonitätsprüfung.</li>
				<li>Forderungen können an einen externen Dienstleister zur Debitorenbuchhaltung oder zum Inkasso übergeben werden.</li>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				5. Eigentumsvorbehalt
			</div>
			<div class="text-block-content">
				<p>Bis zur vollständigen Zahlung bleiben alle gelieferten Waren Eigentum der Apotheke.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				6. Lieferung und Versand
			</div>
			<div class="text-block-content">
				<li>Die Lieferung erfolgt an die vom Kunden angegebene Adresse innerhalb Deutschlands, sofern nichts anderes vereinbart ist.</li>
				<li>Die Übergabe verschreibungspflichtiger Arzneimittel erfolgt ausschließlich gegen Vorlage eines gültigen amtlichen Ausweisdokuments (Personalausweis, Reisepass o. Ä.).</li>
				<li>Die Lieferung erfolgt in der Regel innerhalb von zwei Werktagen nach Eingang des Originalrezepts und Prüfung der Bestelldaten, soweit das Arzneimittel verfügbar ist. Bei Rezepturarzneimitteln können herstellungsbedingt ebenfalls längere Wartezeiten möglich sein.</li>
				<li>Bei Produkten wie medizinischem Cannabis kann es aufgrund gesetzlicher Vorgaben oder Verfügbarkeiten zu längeren Lieferzeiten kommen.</li>
				<li>Auf Wunsch ist eine Abholung in der Apotheke möglich.</li>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				7. Widerrufsrecht
			</div>
			<div class="text-block-content">
				<div class="font-bold">Widerrufsbelehrung</div>
				<div class="font-bold">Widerrufsrecht</div>
				<p>Sie können Ihre Bestellung innerhalb von vierzehn Tagen ohne Angabe von Gründen widerrufen.</p>
				<p>Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter die Ware erhalten haben.</p>
				<p>Um den Widerruf auszuüben, reicht es, wenn Sie uns (siehe oben) innerhalb der Frist eine eindeutige Nachricht schicken, z. B. per Brief oder E-Mail.</p>
				<div class="font-bold">Folgen des Widerrufs</div>
				<p>Wenn Sie Ihre Bestellung widerrufen, erstatten wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (außer Mehrkosten, die durch eine andere Art der Lieferung als die günstigste Standardlieferung entstanden sind). Die Rückzahlung erfolgt unverzüglich, spätestens jedoch innerhalb von vierzehn Tagen nach Eingang Ihres Widerrufs. Wir nutzen dasselbe Zahlungsmittel, das Sie verwendet haben, es sei denn, es wird etwas anderes vereinbart.</p>
				<p>Wir können die Rückzahlung verweigern, bis wir die Waren zurückerhalten haben.</p>
				<div class="font-bold">Rücksendungen</div>
				<p>Sie müssen die Waren spätestens vierzehn Tage nach Ihrem Widerruf an uns zurücksenden. Die Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist absenden.</p>
				<div class="font-bold">Ausschluss des Widerrufsrechts</div>
				<p>In folgenden Fällen können Sie Ihre Bestellung leider nicht widerrufen:</p>
				<li>bei Waren, die nach Kundenspezifikation angefertigt oder eindeutig auf Ihre persönlichen Bedürfnisse zugeschnitten sind,</li>
				<li>bei Waren, die schnell verderben können oder deren Verfallsdatum schnell überschritten würde,</li>
				<li>bei versiegelten Waren, die aus Gründen des Gesundheitsschutzes oder der Hygiene nicht zur Rückgabe geeignet sind, wenn ihre Versiegelung nach der Lieferung entfernt wurde,</li>
				<li>insbesondere bei Arzneimitteln, einschließlich medizinischem Cannabis, sobald deren Versiegelung geöffnet oder beschädigt wurde.</li>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				8. Gewährleistung und Haftung
			</div>
			<div class="text-block-content">
				<li>Es gelten die gesetzlichen Gewährleistungsrechte.</li>
				<li>Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) ist die Haftung der Apotheke auf den vertragstypischen, vorhersehbaren Schaden beschränkt. Eine weitergehende Haftung ist ausgeschlossen.</li>
				<li>Diese Haftungsbeschränkung gilt auch zugunsten der gesetzlichen Vertreter, Mitarbeiter und Erfüllungsgehilfen der Apotheke.</li>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				9. Beratungspflicht
			</div>
			<div class="text-block-content">
				<p>Die Apotheke weist darauf hin, dass bei der Abgabe von Arzneimitteln, insbesondere bei medizinischem Cannabis, eine pharmazeutische Beratung stattfindet. Der Kunde ist verpflichtet, wahrheitsgemäße Angaben zu seiner Medikation und Gesundheit zu machen, soweit dies für eine sichere Arzneimittelabgabe erforderlich ist.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				10. Online-Streitbeilegung
			</div>
			<div class="text-block-content">
				<p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie unter https://ec.europa.eu/consumers/odr/ finden.</p>
				<p>Die Apotheke ist nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				11. Datenschutz
			</div>
			<div class="text-block-content">
				<p>Alle personenbezogenen Daten werden von der Apotheke vertraulich und nach Maßgabe der geltenden Datenschutzgesetze verarbeitet. Details entnehmen Sie bitte der Datenschutzerklärung auf unserer Website.</p>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				12. Kundendienst / Pflichten des Kunden			</div>
			<div class="text-block-content">
				<li>Für Rückfragen, Reklamationen oder Anfragen steht Ihnen unser Kundenservice unter cannabis-einhorn&#64;patriamed.de zur Verfügung.</li>
				<li>Der Kunde verpflichtet sich, die Rechte der Mitarbeiter der Apotheke, insbesondere das Persönlichkeitsrecht, zu respektieren. Bei Beleidigungen, Bedrohungen oder sonstigen strafrechtlich relevanten Handlungen behält sich die Apotheke vor, das virtuelle Hausrecht auszuüben und Kunden vom Service auszuschließen.</li>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				13. Anwendbares Recht, Gerichtsstand
			</div>
			<div class="text-block-content">
				<li>Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.</li>
				<li>Verbraucher genießen die Rechte zwingender Vorschriften des Staates, in dem sie ihren gewöhnlichen Aufenthalt haben.</li>
				<li>Sofern der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen ist, ist der Sitz der Apotheke ausschließlicher Gerichtsstand.</li>
			</div>
		</div>

		<div class="text-block">
			<div class="text-block-header">
				14. Schlussbestimmungen
			</div>
			<div class="text-block-content">
				<p>Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
				<div class="font-bold">Stand: Juli 2025</div>
			</div>
		</div>
		<div class="text-block">
			<div class="text-block-header">
				Widerrufsmuster
			</div>
			<div class="text-block-content">
				<p>(Wenn Sie den Vertrag widerrufen wollen, füllen Sie bitte dieses Formular aus und senden Sie es zurück.)</p>
				<li>An Einhorn-Apotheke Bad Windsheim – Dr. Philipp Hohnstein e.K. , Marktplatz 3, 91438 Bad Windsheim, 09841 - 2074, einhorn-apotheke&#64;patriamed.de:</li>
				<li>Hiermit widerrufe(n) ich/wir () den von mir/uns () abgeschlossenen Vertrag über die Lieferung der folgenden Waren () / die Erbringung der folgenden Dienstleistung ()</li>
				<li>Bestellt am () / erhalten am ()</li>
				<li>Name des/der Verbraucher(s)</li>
				<li>Anschrift des/der Verbraucher(s)</li>
				<li>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)</li>
				<li>Datum</li>
				<p>(*) Unzutreffendes streichen.</p>
			</div>
		</div>
	</div>
</div>

